import React from 'react';
import { motion } from 'framer-motion';

const Boxtxt = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 60, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 1.2 }}
      viewport={{ once: false, amount: 0.3 }}
      className="bg-white py-12 px-4 sm:py-16 sm:px-6 md:py-20 lg:py-24"
      style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}
    >
      <div id="aboutus" className=" scroll-mt-40 max-w-xs mx-auto text-center sm:max-w-md md:max-w-2xl lg:max-w-4xl xl:max-w-5xl">
        <h2 className="text-xl text-gray-800 font-normal" style={{ fontSize: '32px' }}>
          Explore majestic landscapes, bond with rare horses, and sleep under starry skies <br />
        </h2>
        <p
          className="text-gray-700 text-base sm:text-lg leading-relaxed"
          style={{ fontSize: '16px' }}
        >
        <br />Ashwalaya is more than a stable—it is a sanctuary of tradition, trust, and true horsemanship. We specialize in providing immersive horseback safaris that connect you to the desert soul of Rajasthan. Our focus is the well-being of our horses, maintained through proper nutrition, daily grooming, open paddocks, and emotional bonding.
        <br />
        We offer authentic, cultural, and spiritual horse journeys led by skilled horsemen and the majestic Marwari horses, known for their loyalty, beauty, and bravery.
       </p><br />
        <div>
          <a
            href="#book-now"
            className="inline-block border border-black px-4 py-2 rounded-full font-medium hover:bg-black hover:text-white transition-all duration-300 sm:px-5 sm:py-2.5 md:px-6 md:py-3 lg:px-8 lg:py-4 xl:px-10 xl:py-5"
            style={{ fontSize: '14px' }}
          >
            Book Your Ride
          </a>
        </div>
      </div>
    </motion.section>
  );
};

export default Boxtxt;